import VDistpicker from 'v-distpicker'
import { DIST_PICKER } from '../type_name'
import commonMixins from './commonMixins'
import AreaSource from '@/libs/dist_picker_source.js'

export default {
    name: DIST_PICKER,
    mixins: [ commonMixins ],
    render(h) {
        const {
            province_key,
            province_name_key,
            city_key,
            city_name_key,
            area_key,
            area_name_key,
            _type,
            ...params 
        } = this.field
        // params.type = _type
        // 映射三个选项
        params.province = province_key ? this.my_value[province_key] : province_name_key ? this.my_value[province_name_key] : null
        params.city = city_key ? this.my_value[city_key] : city_name_key ? this.my_value[city_name_key] : null
        params.area = area_key ? this.my_value[area_key] : area_name_key ? this.my_value[area_name_key] : null
        // 省市区数据源
        params.provinceSource = AreaSource.province_list
        params.citySource = AreaSource.city_list
        params.areaSource = AreaSource.area_list
        return h(VDistpicker, {
            props: params,
            on: {
              'selected':(data) => {
                console.log('selected distpicker', data)
                this.my_value[province_key] = data.province.code
                this.my_value[province_name_key] = data.province.value
                this.my_value[city_key] = data.city.code
                this.my_value[city_name_key] = data.city.value
                this.my_value[area_key] = data.area.code
                this.my_value[area_name_key] = data.area.value
              },
              'change': (data) => {
                console.log('change distpicker', data)
                this.my_value[province_key] = data.province.code
                this.my_value[province_name_key] = data.province.value
                this.my_value[city_key] = data.city.code
                this.my_value[city_name_key] = data.city.value
                this.my_value[area_key] = data.area.code
                this.my_value[area_name_key] = data.area.value
              },
              'province': (data) => {
                console.log('province distpicker', data)
                this.my_value[province_key] = data.code
                this.my_value[province_name_key] = data.value
              },
              'change-province': (data) => {
                console.log('change-province distpicker', data)
                this.my_value[province_key] = data.code
                this.my_value[province_name_key] = data.value
              },
              'city': (data) => {
                console.log('city distpicker', data)
                this.my_value[city_key] = data.code
                this.my_value[city_name_key] = data.value
              },
              'change-city': (data) => {
                console.log('change-city distpicker', data)
                this.my_value[city_key] = data.code
                this.my_value[city_name_key] = data.value
              },
              'area': (data) => {
                console.log('area distpicker', data)
                this.my_value[area_key] = data.code
                this.my_value[area_name_key] = data.value
              },
              'change-area': (data) => {
                console.log('change-area distpicker', data)
                this.my_value[area_key] = data.code
                this.my_value[area_name_key] = data.value
              }
            }
        })
    }
}